import { Route, Routes } from 'react-router-dom';

import { TreatmentPlanVersionGate } from './components';

export default function TreatmentPlan() {
  return (
    <Routes>
      <Route path=":treatmentPlanId/*" element={<TreatmentPlanVersionGate />} />
      <Route path="*" element={<TreatmentPlanVersionGate />} />
    </Routes>
  );
}
